module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "footer-view"
  }, [_c('VwFooter', [_c('a', {
    attrs: {
      "href": "#"
    },
    slot: "link"
  }, [_vm._v("link-1")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    slot: "link"
  }, [_vm._v("link-2")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    slot: "link"
  }, [_vm._v("link-3")]), _vm._v(" "), _c('span', {
    slot: "text"
  }, [_vm._v("Copyright © 2016 vuwe.me")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-55c5455e!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/footersView.vue
// module id = 245
// module chunks = 0